import { useHistory } from "react-router-dom";
import { ImportacaoBoardCard } from "../../../services/ImportarRazaoService";

const dataHora = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleString("pt-BR") : "—";

interface Props {
  card: ImportacaoBoardCard;
  periodo: string;
  onClose: () => void;
}

/** Modal só-leitura de um card já concluído (DEVN3-540). */
const ModalResumoImportacao = ({ card, periodo, onClose }: Props) => {
  const history = useHistory();

  return (
    <div
      style={{
        position: "fixed", inset: 0, background: "rgba(15, 23, 42, 0.4)", zIndex: 9999,
        display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(4px)",
      }}
      onClick={onClose}
    >
      <div
        className="card shadow-lg"
        style={{ width: 520, maxWidth: "92vw", borderRadius: 16, border: "none" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="card-header d-flex justify-content-between align-items-center py-4 px-5" style={{ background: "#F8FAFC", borderRadius: "16px 16px 0 0" }}>
          <h3 className="card-title fw-bolder text-dark m-0" style={{ fontSize: 18 }}>Importação concluída</h3>
          <button className="btn btn-icon btn-sm btn-active-light-primary" onClick={onClose}>
            <i className="bi bi-x fs-2" />
          </button>
        </div>

        <div className="card-body p-5">
          <div className="d-flex flex-column gap-1 mb-4">
            <span className="text-dark fw-bold fs-5">{card.empresaNome || `Empresa ${card.empresaId}`}</span>
            {card.cnpj && <span className="text-muted fs-7">CNPJ: {card.cnpj}</span>}
            <span className="text-muted fs-7">Período: {periodo}</span>
          </div>

          <div className="row g-3">
            <div className="col-6">
              <div className="bg-light p-3 rounded-3">
                <div className="text-muted fs-8 fw-bold text-uppercase mb-1">Contas classificadas</div>
                <div className="text-dark fw-bold">{card.contasClassificadas} / {card.totalContas}</div>
              </div>
            </div>
            <div className="col-6">
              <div className="bg-light p-3 rounded-3">
                <div className="text-muted fs-8 fw-bold text-uppercase mb-1">Concluída em</div>
                <div className="text-dark fw-bold">{dataHora(card.etapaConcluidaEm)}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="card-footer d-flex justify-content-between py-4 px-5 bg-light-soft" style={{ borderRadius: "0 0 16px 16px" }}>
          <button className="btn btn-sm btn-secondary px-4" onClick={onClose}>Fechar</button>
          <button className="btn btn-sm btn-primary px-4" onClick={() => history.push("/andamento-contas")}>
            Abrir andamento de contas
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalResumoImportacao;
